import { Box } from '@mui/material';
import formatCurrency from 'src/compass/shared/util/formatCurrency';
import ICasRenderCellProps from '../ICasRenderCellProps';
import getCasTableCellValue from '../getCasTableCellValue';

export function CasRenderCurrency(props: ICasRenderCellProps) {
  // Get the value from the row object using the column field
  const value = getCasTableCellValue(props);

  return value != null && <Box textAlign="right">{formatCurrency(value)}</Box>;
}
